import { Injectable, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';
import { AppState } from '@store/app.state';
import { selectEncryptedTenantKey } from '@store/selectors/tenant.selectors';
import { environment } from '@env/environment';

@Injectable({
    providedIn: 'root',
})
export class TenantService implements OnDestroy {
    private destroy$ = new Subject<void>();
    private decryptedTenantKey: string | null = null;

    constructor(private store: Store<AppState>) {}

    getTenantKey(): string | null {
        this.store
            .select(selectEncryptedTenantKey)
            .pipe(takeUntil(this.destroy$))
            .subscribe((key: string | null) => {
                if (key) {
                    this.decryptedTenantKey = CryptoJS.AES.decrypt(key, environment.tenantKeyPassphrase).toString(CryptoJS.enc.Utf8);
                } else {
                    this.decryptedTenantKey = null;
                }
            });
        return this.decryptedTenantKey;
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
